import { AxiosRequest } from "../../../Url";
import { getRightsData } from "../../Tools/Tools";
import { CreateCollapsibleRecords } from "../GridTools/collapsibleRecordsTools";
import { parseColumns, ParsedColumn } from "../GridTools/parseColumnTools";
import { getPayTypesColumnsForSection, payTypesColumnsForPrograms } from "./Columns/payTypesColumns";
import smetaAxios from "../../../SmetaAxios";
import { createGrid, createRecordSource, mfDelete, mfEdit } from "../rcsgrid";
import { PayTypeOption } from "../../Tools/Consts";
import { Status } from "../../Tools/ProjectX";

export async function payTypesGrid(grid: createGrid, source: createRecordSource, props, data) {
  const currentPayTypeIsConfig = () => {
    return source.getFieldTextSync("ID") < 0;
  };
  const isConfigMode = false;

  source.onHandleRequest = handleRequestForPayTypes(props);
  source.CreateCollapsibleRecords = CreateCollapsibleRecords;

  await source.open();

  const codeField = source.fields[source.getFieldIndex("Code")];

  let columns;
  if (data.Columns) {
    switch (data.Columns) {
      case "Section":
        columns = getPayTypesColumnsForSection(codeField, data.json);
        break;
      case "Programs":
        columns = payTypesColumnsForPrograms;
        break;
      default:
        break;
    }
  }

  //парсинг полей запроса GetTableLayout
  if (data.json && data.json.Columns) {
    source.rights = getRightsData(data.json.Rights);
    columns = parseColumns(data.json, { inputColumns: columns });
    grid.setColumns(columns);
    source.rights = getRightsData(data.json.Rights);
  } else {
    grid.setColumns(columns);
    source.rights = getRightsData("-1");
  }
  if (data.Columns === "Section") {
    grid.canModify = (flag: number, column: ParsedColumn | undefined, grid: createGrid) => {
      if (!grid.localCanModify(flag, column, grid)) return false;
      const fieldName = column?.fieldName || "";
      if (fieldName === "Etalon") {
        const recordState = source.getRecordInfo().recordState || 0;
        if ((recordState & Status.Grouped) === 0) {
          return !(Number(source.getFieldValueSync("Атрибуты")) & PayTypeOption.Unused);
        }
      }
      const isUserColumn = ["Title", "ShortCode", "ImageIndex", "Name", "Параметры", "Атрибуты"].includes(fieldName);
      if (currentPayTypeIsConfig()) {
        if (flag === mfDelete) return false;
        if (flag === mfEdit) return isUserColumn;
      } else {
        if (!isConfigMode) {
          if (flag === mfDelete) return source.getFieldTextSync("ShortName") === "";
          if (flag === mfEdit)
            return fieldName !== "ShortName" && (source.getFieldTextSync("ShortName") === "" || isUserColumn);
        }
      }
      return true;
    };

    grid.setImageFields(["ID"]);
    source.booksGetImage = (): string | number => {
      if (!isConfigMode) {
        if (currentPayTypeIsConfig()) return 3;
        if (source.getFieldTextSync("ShortName") !== "") return 2;
      }
      return "";
    };
  }

  source.onRecordCollapsed = async (event) => {
    const recordIndex = event.currentTarget !== undefined ? event.currentTarget.getAttribute("recordindex") : event;
    await smetaAxios.get("RecordCollapsed", {
      prefix: props.Module,
      params: { SectionID: props.SectionID, ObjType: props.ObjType, RecordIndex: recordIndex },
      loadMask: true,
    });
    await grid.refreshSource("!");
    data.setCountRecords?.(source.recordCount);
  };

  if (data.setSelectedRecord || data.setSelectedRecordCode) {
    source.onRecordIndexChanged = async (source) => {
      data.setSelectedRecord?.(source.getFieldTextSync("ID"));
      data.setSelectedRecordCode?.(source.getFieldValueSync("Code"));
    };
  }
  source.first();

  await grid.setSource(source);

  if (props.ID) await grid.refreshSource(props.ID);

  await grid.updateGridSize();

  data.setCountRecords?.(source.recordCount);
  data.setSelectedRecord?.(source.getFieldTextSync("ID"));
  data.setSelectedRecordCode?.(source.getFieldValueSync("Code"));
}

export function handleRequestForPayTypes(props) {
  return (request, loadCursor, wsm, subParams) => {
    const params = new Map();
    params
      .set("prefix", props.Module)
      .set("comand", "HandleTable")
      .set("ObjType", props.ObjType)
      .set("SectionID", props.SectionID);
    if (props.GroupID) params.set("GroupID", props.GroupID);
    if (wsm) params.set("WSM", "1");
    if (subParams) {
      const sParams = Object.entries(subParams);
      sParams.forEach(([key, value]) => {
        params.set(key, value);
      });
    }
    return AxiosRequest(loadCursor !== undefined ? loadCursor : true, params, request);
  };
}
